// src/pages/buyer/ProfilePage.jsx
import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '../../context/AuthContext'
import { profileApi } from '../../api/services'
import { Card, CardHeader, CardBody, Button } from '../../components/common/ui'
import toast from 'react-hot-toast'

export default function ProfilePage() {
  const { user } = useAuth()
  const qc = useQueryClient()
  const [form, setForm] = useState({ name: user?.name || '', email: user?.email || '', phone: user?.phone || user?.mobile || '', business_name: user?.business_name || '', gstin: user?.gstin || '' })
  const [pwd, setPwd] = useState({ current_password: '', password: '', password_confirmation: '' })
  const set = (k) => e => setForm(f => ({ ...f, [k]: e.target.value }))
  const setPw = (k) => e => setPwd(p => ({ ...p, [k]: e.target.value }))

  const update = useMutation({ mutationFn: () => profileApi.update(form), onSuccess: () => { toast.success('Profile updated'); qc.invalidateQueries(['me']) } })
  const changePwd = useMutation({ mutationFn: () => profileApi.updatePassword(pwd), onSuccess: () => { toast.success('Password changed'); setPwd({ current_password:'', password:'', password_confirmation:'' }) }, onError: e => toast.error(e.response?.data?.message || 'Failed') })

  return (
    <div className="max-w-xl space-y-6">
      <h1 className="text-xl font-display font-bold">My Profile</h1>

      <Card>
        <CardHeader><span className="font-bold text-sm">Personal Information</span></CardHeader>
        <CardBody className="space-y-3">
          <input className="input w-full" placeholder="Full name" value={form.name} onChange={set('name')} />
          <input className="input w-full" type="email" placeholder="Email" value={form.email} onChange={set('email')} />
          <input className="input w-full" placeholder="Phone" value={form.phone} onChange={set('phone')} />
          <input className="input w-full" placeholder="Business name (optional)" value={form.business_name} onChange={set('business_name')} />
          <input className="input w-full" placeholder="GSTIN (optional)" value={form.gstin} onChange={set('gstin')} maxLength={15} />
          <Button loading={update.isPending} onClick={() => update.mutate()}>Save Changes</Button>
        </CardBody>
      </Card>

      <Card>
        <CardHeader><span className="font-bold text-sm">Change Password</span></CardHeader>
        <CardBody className="space-y-3">
          <input className="input w-full" type="password" placeholder="Current password" value={pwd.current_password} onChange={setPw('current_password')} />
          <input className="input w-full" type="password" placeholder="New password" value={pwd.password} onChange={setPw('password')} />
          <input className="input w-full" type="password" placeholder="Confirm new password" value={pwd.password_confirmation} onChange={setPw('password_confirmation')} />
          <Button loading={changePwd.isPending} onClick={() => changePwd.mutate()} disabled={!pwd.current_password || !pwd.password}>Update Password</Button>
        </CardBody>
      </Card>
    </div>
  )
}
